import React from 'react';
import { Search, X } from 'lucide-react';

// Small text box that narrows a long filter list as the customer types.
const FilterSearchInput = ({ value, onChange, placeholder }) => (
  <div className="relative mb-2">
    <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label={placeholder}
      className="w-full pl-8 pr-7 py-1.5 text-sm border border-gray-300 rounded-lg focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-200"
    />
    {value && (
      <button
        type="button"
        onClick={() => onChange('')}
        aria-label="Clear"
        className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
      >
        <X className="w-4 h-4" />
      </button>
    )}
  </div>
);

export default FilterSearchInput;
